import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScoreIndicator from 'Assets/Images/score_blue.png';
import './ScoreBar.css';

class ScoreBar extends Component {
  constructor(props) {
    super(props);
    this.scoreValue = React.createRef();
    this.state = {
      scoreValueWidth: 0,
    };
  }

  componentDidMount() {
    this.updateWidth();
  }

  componentDidUpdate(prevProps, state) {
    if (state.scoreValueWidth === 0 && this.scoreValue.offsetWidth !== 0) {
      this.updateWidth();
    }
  }

  updateWidth() {
    this.setState({
      scoreValueWidth: this.scoreValue.offsetWidth,
    });
  }

  calculateScorePosition(calculationScore) {
    const { scoreValueWidth } = this.state;
    const { highScore } = this.props;
    const formattedHighScore = highScore.replace('%', '');
    const formattedScore = calculationScore.replace('%', '');
    let indicatorPosition = 'left';

    // Calculate the percentage position
    const scorePosition = (formattedScore / formattedHighScore) * 100;
    if (scorePosition >= 95) {
      indicatorPosition = 'right';
    } else if (scorePosition > 5) {
      indicatorPosition = 'center';
    }

    if (indicatorPosition === 'center') {
      return {
        scorePosition: `calc(${scorePosition}% - ${scoreValueWidth / 2}px)`,
        indicatorPosition,
      };
    }
    if (indicatorPosition === 'right') {
      return {
        scorePosition: `calc(${scorePosition}% - ${scoreValueWidth}px)`,
        indicatorPosition,
      };
    }

    return { scorePosition: `${scorePosition}%`, indicatorPosition };
  }

  render() {
    const {
      score,
      lowScore,
      highScore,
      scoreLabel,
      firstName,
      flipGradient,
    } = this.props;
    let displayScore = score;
    let calculationScore = score;

    if (
      parseInt(score.replace('%', ''), 10)
      > parseInt(highScore.replace('%', ''), 10)
    ) {
      displayScore = `${highScore}+`;
      calculationScore = highScore;
    }

    const { scorePosition, indicatorPosition } = this.calculateScorePosition(
      calculationScore,
    );

    return (
      <div className="score">
        <div className="score-indicator">
          <div
            className="score-value"
            ref={(scoreValue) => {
              this.scoreValue = scoreValue;
            }}
            style={{
              left: `${scorePosition}`,
              background: `url(${ScoreIndicator}) bottom ${indicatorPosition} no-repeat`,
            }}
          >
            {firstName && <div className="name">{firstName}</div>}
            {parseInt(score.replace('%', ''), 10) >= 0 && displayScore}
          </div>
        </div>
        <div
          className={flipGradient ? 'score-bar flip' : 'score-bar'}
          ref={this.scoreBar}
        >
          <span className="low-score label">{lowScore}</span>
          <span className="high-score label">{highScore}</span>
        </div>
        <div className="score-label">{scoreLabel}</div>
      </div>
    );
  }
}

ScoreBar.propTypes = {
  highScore: PropTypes.string.isRequired,
  score: PropTypes.string.isRequired,
  lowScore: PropTypes.string.isRequired,
  scoreLabel: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  flipGradient: PropTypes.bool,
};

ScoreBar.defaultProps = {
  firstName: '',
  flipGradient: false,
};

export default ScoreBar;
